module.exports = __webpack_public_path__ + "img/red-desert-decal-06.e640f3cc.png";